exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".buttonSubmitColor {\n  background-color: gray; }\n\nlabel input {\n  display: none;\n  /* <--hide */ }\n\nlabel span {\n  /* <--new */\n  height: 12px;\n  width: 12px;\n  border: 1px solid gray;\n  display: inline-block;\n  position: relative;\n  background-color: #FFF;\n  border-radius: 2px;\n  padding: 3px; }\n\n[type=checkbox]:checked + span:before {\n  /* <-- add icon  */\n  content: '\\2714';\n  position: absolute;\n  top: -16px;\n  left: -2px;\n  font-size: 23px;\n  color: #17873E; }\n\n@media screen {\n  .frendlyStatus {\n    display: none; } }\n\n@media print {\n  .frendlyStatus {\n    display: block; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/stages/summary-stage/summary-stage.component.scss
// module id = jqFR
// module chunks = 2